<div class="Typography" style="padding-bottom: 4px;padding-bottom: 4px; width: 100%; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
    <div class="H6" style="align-self: stretch; color: rgba(0, 0, 0, 0.87); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">Property Owner</div>
</div>
<form [formGroup]="propertyOwnerForm">
    <div class="row">
        <mat-form-field class="mat-form-field-100"  appearance="outline">
            <mat-label style="font-size: 16px !important;">First name</mat-label>
            <input matInput  formControlName="firstName"  placeholder="First name"
            > 
            <mat-error>First name is required</mat-error>
          </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="mat-form-field-100"  appearance="outline">
            <mat-label style="font-size: 16px !important;">Last name</mat-label>
            <input matInput  formControlName="lastName"  placeholder="Last name"
            > 
            <mat-error>Last name is required</mat-error>
          </mat-form-field>
    </div>

 
    <div class="row">
        <mat-form-field class="mat-form-field-100"  appearance="outline">
            <mat-label style="font-size: 16px !important;">Email address</mat-label>
            <input matInput formControlName="email"  placeholder="Email address"
            required> 
            <mat-error
            *ngIf="this.propertyOwnerForm.get('email')?.errors?.['required'] && (propertyOwnerForm.get('email')?.touched)">Owner’s
            email address is required</mat-error>
            <mat-error *ngIf="this.propertyOwnerForm.get('email')?.errors?.['pattern'] && (propertyOwnerForm.get('email')?.touched)">
            Email address is invalid</mat-error>
          </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="mat-form-field-100"  appearance="outline">
            <mat-label style="font-size: 16px !important;">Phone number</mat-label>
            <input matInput appPhoneFormat formControlName="phone"   placeholder="Phone number"
            required> 
            <mat-error *ngIf="this.propertyOwnerForm.get('phone')?.errors?.['pattern'] && (propertyOwnerForm.get('phone')?.touched)">Phone number is invalid</mat-error>
         
            <mat-error  *ngIf="this.propertyOwnerForm.get('phone')?.errors?.['required'] && (propertyOwnerForm.get('phone')?.touched)">Phone number is required</mat-error>

          </mat-form-field>
        </div>

    <div class="row">
        <mat-radio-group [value]="addressType" (change)="radioChangeAddress($event)">
            <mat-radio-button value="1">Domestic address</mat-radio-button>
            <mat-radio-button value="2">International address</mat-radio-button>
        </mat-radio-group>
    </div>

    <ng-container *ngIf="addressType === '1'">
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Street address</mat-label>
                <input matInput formControlName="ownerStreetAddress" placeholder="Street address">
                <mat-error>Street address is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Apt/Unit/Suite</mat-label>
                <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite">
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">City</mat-label>
                <input matInput formControlName="city" placeholder="City">
                <mat-error>City is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">State</mat-label>
                <mat-select formControlName="state">
                    <mat-option *ngFor="let s of states" [value]="s.id.toString()">{{ s.name }}</mat-option>
                </mat-select>
                <mat-error>State is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Zip code</mat-label>
                <input matInput formControlName="zipCode" placeholder="Zip code">
                <mat-error *ngIf="propertyOwnerForm.get('zipCode')?.errors?.['required']">Zip code is required</mat-error>
                <mat-error *ngIf="propertyOwnerForm.get('zipCode')?.errors?.['pattern']">Zip code is invalid</mat-error>
            </mat-form-field>
        </div>
    </ng-container>

    <ng-container *ngIf="addressType === '2'">
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Address name</mat-label>
                <input matInput formControlName="addressName" placeholder="Address name">
                <mat-error>Address name is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Street address / PO box</mat-label>
                <input matInput formControlName="addressOrPoBox" placeholder="Street address / PO box">
                <mat-error>Street address / PO box is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">City / State / Province</mat-label>
                <input matInput formControlName="cityStateProvince" placeholder="City / State / Province">
                <mat-error>City / State / Province is required</mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="mat-form-field-100" appearance="outline">
                <mat-label style="font-size: 16px !important;">Country</mat-label>
                <mat-select formControlName="country">
                    <mat-option *ngFor="let c of country" [value]="c.id.toString()">{{ c.name }}</mat-option>
                </mat-select>
                <mat-error>Country is required</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
<div class="Dialogactions" style="width: 100%; padding: 8px 0 0; justify-content: flex-end; align-items: center; gap: 8px; display: inline-flex">
    <button (click)="dialogRef.close()" mat-stroked-button mat-button mat-dialog-close class="button-stepper-allow-outline">
        GO BACK
        <mat-icon>arrow_left_alt</mat-icon>
     </button>
     <button [disabled]="!propertyOwnerForm.valid"  [ngClass]="{'button-stepper-allow': propertyOwnerForm.valid ,'button-stepper': propertyOwnerForm.invalid  }"  
     mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SAVE <mat-icon>save</mat-icon></button>
</div>
